module.exports = __webpack_public_path__ + "img/qr-code.5cc43aa8.png";